import { Directive, HostListener, EventEmitter, Output } from '@angular/core';

@Directive({
  selector: '[appPanel]',
})
export class PanelDirective {
  @Output() elementHovered = new EventEmitter();

  constructor() {}

  @HostListener('mouseover', ['$event'])
  onMouseOver(evt: MouseEvent) {
    evt.preventDefault();
    const target = evt.target;
    const type = evt.type;
    const data = {
      target,
      type,
    };
    if (target) {
      this.elementHovered.emit(data);
    }
  }

  @HostListener('mouseout', ['$event'])
  onMouseOut(evt: MouseEvent) {
    evt.preventDefault();
    const target = evt.target;
    const type = evt.type;
    const data = {
      target,
      type,
    };
    if (target) {
      this.elementHovered.emit(data);
    }
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(evt: MouseEvent) {
    evt.preventDefault();
    const target = evt.target;
    const type = evt.type;
    const data = {
      target,
      type,
    };
    if (target) {
      this.elementHovered.emit(data);
    }
  }

  @HostListener('dblclick', ['$event'])
  onClick(evt: MouseEvent) {
    evt.preventDefault();
    const target = evt.target;
    const type = evt.type;
    const data = {
      target,
      type,
    };
    if (target) {
      this.elementHovered.emit(data);
    }
  }
}
